import React, { useContext, useEffect } from "react";
import EcommerceNavbar from "components/Navbars/EcommerceNavbar";
import Footer from "components/Footers/Footer";
import CartDrawer from "components/Modals/CartDrawer";
import BudgetFloatingGauge from "components/BudgetFloatingGauge";
import { UserContext } from "../context/UserContext";
import { getBrandColors } from "../utils/config";
import useLogoutValid from "../hooks/logoutValid"; // Importación corregida
import { useLocation } from "react-router-dom";

export default function MainLayout({ children }) {
  const routerLocation = useLocation();
  const { user } = useContext(UserContext);
  /**
   * 🕒 VIGILANTE DE INACTIVIDAD
   * Cierra sesion tras 60 minutos sin actividad.
   */
  useLogoutValid(60);

  // 🔥 Configuración de colores de marca (CSS Variables)
  useEffect(() => {
    const colors = getBrandColors();

    document.documentElement.style.setProperty("--color-primary", colors.primary);
    document.documentElement.style.setProperty("--color-secondary", colors.secondary);
    document.documentElement.style.setProperty("--color-background", colors.background);
    document.documentElement.style.setProperty("--color-text", colors.text);
  }, []);
const isOrderExpress = routerLocation.pathname === "/order-express";
  return (
    <div className="flex flex-col min-h-screen">
      {/* Elementos persistentes */}
      <EcommerceNavbar fixed />
      {!isOrderExpress && <CartDrawer />}

      {/* Contenedor dinámico de las páginas */}
      <div className="pt-24 flex-1">
        {children}
      </div>

      <Footer />
      <BudgetFloatingGauge user={user} />
    </div>
  );
}